import {ReactElement} from 'react';
import classnames from 'classnames';
import Link from '@frontend/ui-kit/Components/Link';
import {APP_STORE_LINK, GOOGLE_PLAY_LINK} from '../../../constants';
import appStore from '../../../static/images/appStore.svg';
import googlePlay from '../../../static/images/googlePlay.svg';
import downloadQRCode from '../../../static/images/downloadQRCode.svg';
import analyticsService, {ANALYTICS_EVENTS} from '../../../analyticsService';
import './index.scss';

type Props = {
    className?: string
}

const AppDownloadSources = ({className}: Props): ReactElement => {
    const onAndroidLinkClicked = () => analyticsService.track(ANALYTICS_EVENTS.activation.androidStoreLinkClicked);
    const onIOSLinkClicked = () => analyticsService.track(ANALYTICS_EVENTS.activation.IOSStoreLinkClicked);

    return (
        <div className={classnames('app-download-sources', className)}>
            <div className='app-download-sources__qr-code'>
                <img src={downloadQRCode} alt='qr code for downloading app'/>
            </div>
            <Link onClick={onIOSLinkClicked} className='app-download-sources__app-store' data-testid='app-download-app-store' target='_blank' href={APP_STORE_LINK}>
                <img src={appStore} alt='App Store'/>
            </Link>

            <Link onClick={onAndroidLinkClicked} className='app-download-sources__google-play' data-testid='app-download-google-play' href={GOOGLE_PLAY_LINK} target='_blank'>
                <img src={googlePlay} alt='Google Play'/>
            </Link>
        </div>
    );
};

export {AppDownloadSources as TestableAppDownloadSources};
export default AppDownloadSources;
